import Vuex from "vuex";
import Vue from "vue";
import basicstore from "./modules/basicstore.js";

// Load Vuex
Vue.use(Vuex);
Vue.config.devtools = true;

//Create store
const store = new Vuex.Store({ modules: { basicstore } });

export default store;
